export enum AdditionalFieldsSourceType {
    DailyEntry,
    ServiceCall,
    FieldService,
    PurchaseOrder
}
